import { alpha, styled } from '@mui/material';
import { css } from '@emotion/react';
import { UiButton } from 'ui-components';
import { marginRight } from 'utils';

export const StyledSelectNativePlatforms = styled('div')(
  ({ theme }) => css`
    display: flex;
    color: #6c879b;
    text-align: right;
    font-family: inherit;
    font-size: 0.875rem;
    font-weight: 500;
    margin: 30px 0 35px;
    align-items: center;
    .MuiFormControlLabel-root {
      .MuiTypography-root {
        color: ${theme.palette.naturals.black};
        font-weight: 400;
        line-height: 20px;
      }
    }
  `
);

export const StyledToggleButton = styled(UiButton)(
  ({ theme }) => css`
    ${marginRight('12px')}
    border-color:  ${theme.palette.gray.light};
    padding-left: 25px !important;
    padding-right: 25px !important;
    color: ${theme.palette.naturals.black};

    .icon {
      width: 16px;
    }

    &.checked {
      border-color: ${theme.palette.primary.main};
      background-color: ${alpha(theme.palette.primary.main, 0.08)};
    }

    &:hover {
      background-color: ${alpha(theme.palette.primary.main, 0.32)};
    }
  `
);
